import Select from "react-select";

const SelectDropdown = ({ columnName, value, onChange, options, maxWidth = 130 }) => {
  // Find the selected option object from options array
  const selectedOption = options.find((opt) => opt.value === value) || null;

  return (
    <Select
      options={options}
      value={selectedOption}
      onChange={(selected) =>
        onChange({ target: { name: columnName, value: selected?.value || "" } })
      }
      isClearable
      isSearchable
      styles={{
        container: (base) => ({
          ...base,
          maxWidth: `${maxWidth}px`,
          margin: "2px",
        }),
        control: (base) => ({
          ...base,
          minHeight: "30px",
          fontSize: "12px",
        }),
        singleValue: (base) => ({
          ...base,
          fontSize: "12px",
        }),
        option: (base) => ({
          ...base,
          fontSize: "12px",
        }),
        input: (base) => ({
          ...base,
          fontSize: "12px",
        }),
      }}
    />
  );
};

export default SelectDropdown;
